import { UserGuide } from '@/src/components/faq/user-guide/UserGuide';
import React from 'react';

export const UserGuidePage: React.FC = () => {
  return <UserGuide />;
};
